import uuid from 'uuid'
import { random } from '@/utils/number'

import { handleMessageEmit } from '@/methods/message/handleMessageEmit'

import { WS_EVENT_SYSTEM } from '@/constants/socketEvent'

const cid = random()

export function sendHeartBeat({ heartbeatTimer = null, socket, gdata }: any) {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer)
    heartbeatTimer = null
  }

  heartbeatTimer = setInterval(() => {
    const packetBody = {
      id: uuid.v4(),
      timetick: new Date().getTime(),
      region: gdata.region || '',
    }

    const packet = {
      id: 1,
      cid: cid,
      ver: 1,
      ts: new Date().getTime(),
      sid: WS_EVENT_SYSTEM.sid,
      ssid: WS_EVENT_SYSTEM.heartbeat,
      body: packetBody,
    }

    handleMessageEmit({ socket, content: packet })
  }, 20 * 1000)
}
